// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"330":"54fb7287","453":"91943b0d","745":"8160039b"}[chunkId] + ".chunk.js";
};